export default __webpack_public_path__ + "static/media/gamesters-paradise.2555d9e9.png";